import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledTable = /*#__PURE__*/styled.table.withConfig({
  componentId: "sc-storm-ui-30053921__sc-30qvhn-0"
})(["width:100%;border-top:", ";", ""], ({
  theme
}) => theme.table.border, isMobile(css(["border-top:none;"])));
const StyledCaption = /*#__PURE__*/styled.caption.withConfig({
  componentId: "sc-storm-ui-30053921__sc-30qvhn-1"
})(["position:absolute !important;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);"]);
const KeyValueTable = ({
  caption,
  children,
  ...rest
}) => /*#__PURE__*/React__default.createElement(StyledTable, _extends({
  role: "table",
  cellPadding: "0",
  cellSpacing: "0"
}, rest), /*#__PURE__*/React__default.createElement(StyledCaption, null, caption), /*#__PURE__*/React__default.createElement("tbody", null, children));

export { KeyValueTable as K };
//# sourceMappingURL=KeyValueTable-CRL9pP4c.js.map
